<div class="">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 header-titles">
      <div *ngIf="!notices">
        <mat-spinner></mat-spinner>
      </div>
      <section *ngIf="notices">
        <div class="example-button-row">
          <!-- <h1 class="selection-title">AVISOS</h1> -->

          <div *ngIf="notices.length === 0">
            <button disabled="true" [class]="'notices'" style="display: flex; align-items: center; justify-content: center;" [style]="'border: 2px solid #05f51d;' + 'color:#353535;'" mat-stroked-button color="primary">
            <span class="material-symbols-outlined">
              search_check
            </span>
            <label style="font-size: 20px;">
              Sin avisos que mostrar
            </label>
          </button>
          </div>

          <button disabled="true" *ngFor="let notice of notices" [class]="'notices'" [style]="'border: 2px solid #eb4034;' + 'color: ' + '#353535;'" mat-stroked-button color="primary">
            <span class="number-notice-header" [style]="'background-color: #eb4034;'">
              {{ notice.Codlinea }}
            </span>
            <label>
              {{ notice.Texto }}
            </label>
          </button>

        </div>
      </section>
    </div>
  </div>
</div>

<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
